import moment from 'moment'

// Shared helpers for drawn-up ("prepared") medicines - see
// server/src/routers/governance/preparedMedicines.js for the presented shape.

// "Expires in 3h 20m" / "Expired 25m ago"
export const expiryLabel = (expiresAt, now = moment()) => {
  if (!expiresAt) return 'No expiry set'
  const expiry = moment(expiresAt)
  const diff = expiry.diff(now, 'minutes')
  const span = (minutes) => {
    const abs = Math.abs(minutes)
    const hours = Math.floor(abs / 60)
    const mins = abs % 60
    if (hours >= 48) return `${Math.floor(hours / 24)}d`
    return hours ? `${hours}h ${mins}m` : `${mins}m`
  }
  return diff < 0 ? `Expired ${span(diff)} ago` : `Expires in ${span(diff)}`
}

// MUI palette key for an expiry: expired = error, within an hour = warning
export const expiryTone = (expiresAt, now = moment()) => {
  if (!expiresAt) return 'default'
  const minutes = moment(expiresAt).diff(now, 'minutes')
  if (minutes < 0) return 'error'
  if (minutes < 60) return 'warning'
  return 'success'
}

export const bagName = (location) =>
  location
    ? `${location.number ? `${location.number} - ` : ''}${location.name ?? ''}`
    : 'Unknown bag'

export const doseSummary = (prepared) =>
  [
    prepared.dose,
    prepared.volumeMl ? `${prepared.volumeMl}ml` : null,
    prepared.concentration,
  ]
    .filter(Boolean)
    .join(' · ')

// Server errors come back as { error } (4xx) or the ERROR helper's shape
export const apiError = (res, fallback) =>
  res?.data?.error ||
  res?.data?.message ||
  (typeof res?.data === 'string' && res.data.length < 200 ? res.data : '') ||
  fallback
